import ResetError from '@/pages/ResetPassword/error';
import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { z } from 'zod';

const resetPasswordSearchSchema = z.object({
  email: z.string().optional(),
  code: z.union([
    z.string().length(6),
    z.number().refine(n => n.toString().length === 6, { message: 'Code must be 6 digits' }),
  ]),
});

export const Route = createFileRoute('/reset-password/')({
  errorComponent: () => <ResetError />,
  validateSearch: resetPasswordSearchSchema,
});
